import { gql } from 'apollo-angular';

import { TRANSFER_OBJECT_COUNT } from 'src/app/@graphql/operations/fragment';

/**
 * Reads one advance for the detail dialog. Declared here instead of reusing
 * the shared TreasuryObject fragment because only this screen wants
 * `createdBy` and `applications`: both are resolved with their own queries
 * server side, and adding them to the shared fragment would charge every
 * list that uses it.
 */
export const GET_ADVANCE_DETAIL_QUERY = gql`
  query getAdvancePayment($id_treasury: ID, $company: String) {
    getAdvancePayment(id_treasury: $id_treasury, company: $company) {
      id_treasury
      id_correlative
      type
      date
      value
      value_used
      id_ref
      paymentType {
        id_payment
        description
      }
      customer {
        id_cliente
        nombre
      }
      provider {
        id_provider
        nombre
      }
      createdBy {
        id
        name
      }
      applications(company: $company) {
        id
        kind
        documentNumber
        value
        date
      }
    }
  }
`;

/**
 * Lists transfers. Declared here instead of reusing the legacy documents
 * because only this screen filters by origin; the rows themselves are the
 * shared fragment, so both surfaces stay on one row shape.
 */
export const GET_ALL_TRANSFERS_QUERY = gql`
  query getAllTransfers(
    $page: Int
    $size: Int
    $origins: [String]
    $company: String
  ) {
    getAllTransfers(
      page: $page
      size: $size
      origins: $origins
      company: $company
    ) {
      ...TransferObjectCount
    }
  }
  ${TRANSFER_OBJECT_COUNT}
`;

export const SEARCH_TRANSFERS_QUERY = gql`
  query searchTranfers(
    $value: String
    $page: Int
    $size: Int
    $origins: [String]
    $company: String
  ) {
    searchTranfers(
      value: $value
      page: $page
      size: $size
      origins: $origins
      company: $company
    ) {
      ...TransferObjectCount
    }
  }
  ${TRANSFER_OBJECT_COUNT}
`;

/**
 * Reads one transfer for the detail dialog. Its own document, not the shared
 * fragment: only this screen wants `createdBy`, which is resolved with an
 * extra query server side, and the dialog needs none of the invoice detail
 * the list fragment carries.
 */
export const GET_TRANSFER_QUERY = gql`
  query getTransfer($id_transfer: ID, $company: String) {
    getTransfer(id_transfer: $id_transfer, company: $company) {
      id_transfer
      id_correlative
      date
      custom_value
      invoice_payment {
        identifier
      }
      purchase_payment {
        identifier
      }
      original {
        id_payment
        description
      }
      transferred {
        id_payment
        description
      }
      createdBy {
        id
        name
      }
    }
  }
`;
